import {
  ActionIcon,
  Box,
  Button,
  Card,
  Center,
  Checkbox,
  Divider,
  Fieldset,
  Flex,
  Grid,
  Group,
  LoadingOverlay,
  Modal,
  Paper,
  Radio,
  ScrollArea,
  Select,
  Text,
  Textarea,
  TextInput,
  Title,
} from "@mantine/core";
import {
  DateInput,
  DatePickerInput,
  DateTimePicker,
  useDatesContext,
} from "@mantine/dates";
import { hasLength, useForm } from "@mantine/form";
import {
  IconCalendarDue,
  IconChecks,
  IconSearch,
  IconSend,
  IconTimeDuration15,
  IconTrash,
  IconX,
} from "@tabler/icons-react";
import React, { useEffect, useState } from "react";
import className from "./CreateProfile.module.scss";
import { ReactComponent as UploadIcon } from "../../../../src/assets/icon/upload.svg";
import { ReactComponent as UploadIconPlus } from "../../../../src/assets/icon/upload_plus.svg";
import { MessageResponse } from "../../../model/MessageResponse";
import { EmployeeModel } from "../../../model/TblDmEmployee";
import { repositorySign } from "../../../_base/_const/_constVar";
import { Dropzone, MIME_TYPES } from "@mantine/dropzone";
import { useDisclosure } from "@mantine/hooks";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import FileUpload from "./UploadFile/UploadFile";
import { notifications } from "@mantine/notifications";
import { modals } from "@mantine/modals";
import {
  uploadFile,
  UploadFileResult,
} from "../../../_base/extension/Extension";
import {
  SelectListItem,
  SelectListItemBase,
} from "../../../_base/model/_base/SelectListItemBase";
import { TblDocumentCommand } from "../../../model/TblDocumentCommand";
import { useNavigate } from "react-router-dom";
import {
  getDepartmentSelect,
  getUsersSelect,
} from "../../../const/getSelectApi";
import { format, toZonedTime } from "date-fns-tz";
import { formatToVietnamTz } from "../../../_base/extension/DateExtension";

const timeZone = "Asia/Ho_Chi_Minh";
interface UploadedFile {
  bucket: string;
  endPoint: string;
  etag: string;
  objectName: string;
  pathNameBefore: string;
  size: number;
  url: string;
}

const options = [
  { label: "1 Tuần", value: "1" },
  { label: "2 Tuần", value: "2" },
  { label: "3 Tuần", value: "3" },
  { label: "4 Tuần", value: "4" },
];

export const CreateProfile = ({ onClose }: PartnersCreateViewProps) => {
  const navigate = useNavigate();
  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [listEmployee, setListEmployee] = useState<SelectListItem[]>([]);
  const [listDocument, setListDocument] = useState<SelectListItem[]>([]);
  const [listDepartment, setListDepartment] = useState<SelectListItem[]>([]);
  const [listDocType, setListDocType] = useState<SelectListItemBase[]>([]);
  const [listVendor, setListVendor] = useState<SelectListItem[]>([]);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [visibleHandelLoad, setVisibleHandelLoad] = useState(false);
  const [listUploadedFiles, setListUploadedFiles] = useState<
    UploadFileResult[]
  >([]);
  // const [handleDoctypeId, setHandleDoctypeId] = useState<string | null>("");
  // const [listDataDoctypeCreate, setListDataDoctypeCreate] =
  //   useState<DocumentRecord>();
  const [uploadedFiles1, setUploadedFiles1] = useState<UploadFileResult[]>([]);
  const [uploadedFiles2, setUploadedFiles2] = useState<UploadFileResult[]>([]);
  const entity: TblDocumentCommand = {
    id: 0,
    code: "",
    name: "",
    doctypeId: 0,
    relateRecordsId: "",
    description: "",
    employeeId: 0,
    attachments: "",
    signedDocument: "",
  };

  const form = useForm<TblDocumentCommand>({
    mode: "controlled",
    validateInputOnChange: false,
    initialValues: entity,
    validate: {
      name: (value) => {
        if (!value) {
          return "Vui lòng nhập tên hồ sơ!";
        }
        return hasLength(
          { min: 5, max: 150 },
          "Tên phải từ 5-150 kí tự!"
        )(value as string);
      },

      doctypeId: (value) => {
        if (!value) {
          return "Vui lòng chọn loại hồ sơ!";
        }
      },
      code: (value) => {
        if (!value) {
          return "Vui lòng chọn mã hồ sơ!";
        }
      },
      employeeId: (value) => {
        if (!value) {
          return "Vui lòng nhân viên trình ký!";
        }
      },
      // relateRecordsId: (value) => {
      //   if (!value) {
      //     return "Vui lòng chọn hồ sơ liên quan ký!";
      //   }
      // },
      // departmentId: (value) => {
      //   if (!value) {
      //     return "Vui lòng chọn đơn vị trình ký!";
      //   }
      // },
      // partnerId: (value) => {
      //   if (!value) {
      //     return "Vui lòng chọn đối tác!";
      //   }
      // },
    },
  });

  const handleCreateTblDocumentMethod = async (
    dataSubmit: TblDocumentCommand
  ) => {
    console.log(dataSubmit);
    // return
    open();
    setDisabled(true);
    let isValid = true;
    if (!form.getValues().signedDocument && !form.getValues().attachments) {
      isValid = false;
    }

    if (!isValid) {
      NotificationExtension.Fails("Vui lòng chọn file để trình ký!");
      setDisabled(false);
      close();
      return;
    }
    // const formatToVietnamTz = (date?: Date) => {
    //   if (!date) return null;
    //   return format(toZonedTime(date, timeZone), "yyyy-MM-dd'T'HH:mm:ssXXX", { timeZone });
    // };
    const dataApiS = {
      ...dataSubmit,
      createDate: formatToVietnamTz(dataSubmit.createDate),
      signedDate: formatToVietnamTz(dataSubmit.signedDate),
      expirationDate: formatToVietnamTz(dataSubmit.expirationDate),
      startDate: formatToVietnamTz(dataSubmit.startDate),
    };
    const dataApi = await repositorySign.post<
      MessageResponse<TblDocumentCommand>
    >("/api/v1/TblDocument/create", dataApiS);
    if (dataApi?.success) {
      // onClose((prev: any) => !prev);
      NotificationExtension.Success("Thêm thành công !");
      // modals.closeAll();
      setTimeout(() => {
        navigate("/method/folders-task");
      }, 1000);
    } else setDisabled(false);
    close();
  };

  //API get list thêm hồ sơ
  const fetchDataGenerateTblDocument = async () => {
    const response = await repositorySign.get<
      MessageResponse<TblDocumentCommand>
    >("/api/v1/TblDocument/create");
    if (response && response.success) {
      const result = response.data;

      // form.setValues(result);
      // form.resetDirty(result);
      form.initialize(result);
      if (result.createDate)
        form.setFieldValue("createDate", new Date(result.createDate));
      if (result.expirationDate)
        form.setFieldValue("expirationDate", new Date(result.expirationDate));
      if (result.startDate)
        form.setFieldValue("startDate", new Date(result.startDate));
      if (result.signedDate)
        form.setFieldValue("signedDate", new Date(result.signedDate));
      if (result.employeeId)
        form.setFieldValue("employeeId", result.employeeId.toString());
      if (result.departmentId)
        form.setFieldValue("departmentId", result.departmentId.toString());
    }
  };

  //API gọi danh sách nhân viên
  const fetchDataEmployee = async () => {
    const response = await getUsersSelect();
    if (response) {
      setListEmployee(response);
    }

    await fetchDataDocument();
  };
  //API gọi danh sách phòng ban
  const fetchDataDepartment = async () => {
    const response = await getDepartmentSelect();

    if (response) {
      setListDepartment(response);
    }
  };

  //API gọi danh sách hồ sơ liên quan
  const fetchDataDocument = async () => {
    const response = await repositorySign.get<
      MessageResponse<SelectListItem[]>
    >("/api/v1/TblDocument/get-select-relation-document");

    if (response && response.success) {
      let result = response.data;
      setListDocument(result);
    }
    await fetchDataDepartment();
  };

  //API gọi danh sách loại hồ sơ
  const fetchDataDocType = async () => {
    const response = await repositorySign.get<
      MessageResponse<SelectListItemBase[]>
    >("/api/v1/TblDocType/get-select");

    if (response && response.success) {
      let result = response.data;
      setListDocType(result);
    }
  };

  //API gọi danh sách đối tác
  const fetchDataVendor = async () => {
    const response = await repositorySign.get<
      MessageResponse<SelectListItem[]>
    >("/api/v1/TblVendor/get-select");

    if (response && response.success) {
      let result = response.data;
      setListVendor(result);
    }
  };

  useEffect(() => {
    // fetchDataGenerateDocumentCode();
    fetchDataEmployee();
    fetchDataGenerateTblDocument();
  }, []);

  // useEffect(() => {
  //   form.setFieldValue("createDate", new Date());
  //   form.setFieldValue("code", entity.code);
  // }, [entity]);

  useEffect(() => {
    const updateFieldValue = (
      files: UploadedFile[] | null,
      fieldName: string
    ) => {
      if (files && files.length > 0) {
        const urls = files
          .map((file) => file.url)
          .join("||")
          .trim();
        form.setFieldValue(fieldName, urls);
      } else if (files && files.length === 0) {
        form.setFieldValue(fieldName, "");
      }
    };

    updateFieldValue(uploadedFiles1, "signedDocument");
    updateFieldValue(uploadedFiles2, "attachments");
  }, [uploadedFiles1, uploadedFiles2]);

  //Lấy chiều cao mặc định khi header thay đổi
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (160 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  const [isDisabled, setDisabled] = useState(false);

  return (
    <>
      {/* {ModalChildRen()} */}
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
      <Box
        onSubmit={form.onSubmit(async (e: TblDocumentCommand) => {
          await handleCreateTblDocumentMethod(e);
        })}
        style={{ position: "relative" }}
        component="form"
      >
        <Group justify="space-between" p="0 0 10px" ref={headerRef}>
          <Title order={4}>Thêm mới hồ sơ</Title>
          <Flex gap={20}>
            <Button
              disabled={isDisabled}
              leftSection={<IconSend size={14} />}
              variant="outline"
              radius="xl"
              color="green"
              type="submit"
            >
              Lưu và gửi duyệt
            </Button>
            {/* <Button
              leftSection={<IconChecks size={14} />}
              radius="xl"
              color="orange"
              variant="outline"
            >
              Lưu và đóng
            </Button> */}
          </Flex>
        </Group>
        <Grid gutter="xs">
          <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
            <Card
              shadow="sm"
              radius="md"
              withBorder
              p="lg"
              pr={0}
              pt={15}
              style={{
                boxShadow: "0 1px 10px rgba(0, 0, 0, 0.1)",
                maxHeight: height + 55,
                minHeight: height + 55,
              }}
            >
              <ScrollArea w="100%" pr={5} h={height} offsetScrollbars>
                <Grid>
                  <Grid.Col span={{ base: 12 }}>
                    <Select
                      key={form.key("doctypeId")}
                      label="Loại hồ sơ:"
                      placeholder="Vui lòng chọn hồ sơ"
                      nothingFoundMessage="Không có dữ liệu"
                      data={listDocType.map((doctype) => ({
                        value: doctype.value,
                        label: doctype.text,
                      }))}
                      searchable
                      withAsterisk
                      onClick={async () => await fetchDataDocType()}
                      {...form.getInputProps("doctypeId")}
                      onChange={(value) => {
                        form.setFieldValue("doctypeId", value ?? "");
                        if (value) {
                          const code = listDocType.find(
                            (x) => x.value == value
                          )?.att1;
                          form.setFieldValue(
                            "code",
                            code?.toUpperCase() +
                              form.getValues().code.slice(-5)
                          );
                        }
                      }}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12 }}>
                    <TextInput
                      flex={1}
                      key={form.key("name")}
                      label="Tên hồ sơ"
                      placeholder={"Vui lòng chọn tên hồ sơ"}
                      withAsterisk
                      {...form.getInputProps("name")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                    <TextInput
                      readOnly
                      key={form.key("code")}
                      flex={1}
                      label="Mã hồ sơ:"
                      placeholder={"Vui lòng chọn mã hồ sơ"}
                      withAsterisk
                      {...form.getInputProps("code")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
                    <Select
                      key={form.key("employeeId")}
                      label="Nhân viên trình ký:"
                      readOnly
                      placeholder="Vui lòng chọn nhân viên"
                      nothingFoundMessage="Không có dữ liệu"
                      data={listEmployee.map((employee) => ({
                        value: employee.value,
                        label: employee.text,
                      }))}
                      limit={1}
                      // onClick={async () => await fetchDataEmployee()}
                      //  defaultValue={form.getValues().employeeId}
                      searchable
                      withAsterisk
                      {...form.getInputProps("employeeId")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12 }}>
                    <Textarea
                      rows={8}
                      key={form.key("description")}
                      label="Mô tả:"
                      placeholder="Nhập Mô tả"
                      {...form.getInputProps("description")}
                    />
                  </Grid.Col>
                </Grid>
                <Box className={className.DragAndDrop_content}>
                  <Fieldset
                    style={{ display: "flex", justifyContent: "center" }}
                    legend="Tài liệu ký"
                    p={10}
                  >
                    <Flex
                      className={className.style_container}
                      align="center"
                      justify="center"
                      direction="column"
                    >
                      <Box className={className.Box_animation_left}>
                        <Dropzone
                          onDrop={async (acceptedFiles) => {
                            if (acceptedFiles.length > 0) {
                              const res = await uploadFile(acceptedFiles);
                              if (res && res.length > 0)
                                setListUploadedFiles((prev) => [
                                  ...prev,
                                  ...res,
                                ]);
                              res?.forEach((element) => {
                                const value = form.getValues().signedDocument;
                                if (!value || value.length < 1) {
                                  form.setFieldValue(
                                    "signedDocument",
                                    element.url
                                  );
                                } else
                                  form.setFieldValue(
                                    "signedDocument",
                                    value + "||" + element.url
                                  );
                              });
                            } else
                              NotificationExtension.Info(
                                "Vui lòng chọn tập tin !"
                              );
                          }}
                          accept={[MIME_TYPES.pdf]}
                          multiple
                        >
                          <Box className="DragAndDrop_children">
                            <Center>
                              <UploadIcon width={70} height={70} />
                            </Center>
                            <Flex align="center" justify="center" gap={5}>
                              <Text size="sm">Kéo thả File của bạn</Text>
                              <Text td="underline" fw={600} c="blue" size="sm">
                                hoặc chọn tệp tin
                              </Text>
                            </Flex>
                          </Box>
                        </Dropzone>
                      </Box>
                      <Box className={className.Box_animation_right} mt={16}>
                        <Flex
                          align="center"
                          justify="center"
                          direction="column"
                        >
                          {form.getValues().signedDocument?.length > 0 ? (
                            form
                              .getValues()
                              .signedDocument.split("||")
                              .filter((x) => x && x.length > 0)
                              .map((url, index) => (
                                <Group key={index} mt="sm">
                                  <Text size="sm">
                                    {listUploadedFiles.find(
                                      (file) => file.url === url
                                    )?.fileNameBeforeUpdate ??
                                      url.split("/").pop() ??
                                      "Tài liệu"}
                                  </Text>
                                  <Button
                                    leftSection={<IconTrash size={14} />}
                                    color="red"
                                    size="xs"
                                    variant="light"
                                    onClick={() => {
                                      if (url) {
                                        const updatedAttachments = form
                                          .getValues()
                                          .signedDocument.split("||")
                                          .filter(
                                            (item) =>
                                              item !== url && item.length > 0
                                          )
                                          .join("||");
                                        form.setFieldValue(
                                          "signedDocument",
                                          updatedAttachments
                                        );
                                      }
                                    }}
                                  >
                                    Xoá
                                  </Button>
                                </Group>
                              ))
                          ) : (
                            <Text size="sm" c="gray">
                              Không có tệp tin nào được đính kèm
                            </Text>
                          )}
                        </Flex>
                      </Box>
                    </Flex>
                  </Fieldset>
                </Box>
              </ScrollArea>
            </Card>
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
            <Card
              shadow="sm"
              radius="md"
              withBorder
              p="lg"
              pr={0}
              pt={15}
              style={{
                boxShadow: "0 1px 10px rgba(0, 0, 0, 0.1)",
                maxHeight: height + 55,
                minHeight: height + 55,
              }}
            >
              <ScrollArea w="100%" pr={5} h={height + 600} offsetScrollbars>
                <Grid>
                  <Grid.Col span={{ base: 12 }}>
                    <Select
                      key={form.key("relateRecordsId")}
                      flex={1}
                      label="Hồ sơ liên quan:"
                      placeholder="Vui lòng chọn hồ sơ liên quan"
                      nothingFoundMessage="Không có dữ liệu"
                      data={listDocument.map((employee) => ({
                        value: employee.value,
                        label: employee.text,
                      }))}
                      searchable
                      //   withAsterisk
                      {...form.getInputProps("relateRecordsId")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12 }}>
                    <Select
                      key={form.key("departmentId")}
                      readOnly
                      label="Đơn vị trình ký:"
                      placeholder="Vui lòng chọn đơn vị trình ký"
                      nothingFoundMessage="Không có dữ liệu"
                      data={listDepartment.map((employee) => ({
                        value: employee.value,
                        label: employee.text,
                      }))}
                      searchable
                      withAsterisk
                      {...form.getInputProps("departmentId")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 12 }}>
                    <Select
                      key={form.key("parentId")}
                      flex={1}
                      label="Đối tác:"
                      placeholder="Vui lòng chọn đối tác"
                      nothingFoundMessage="Không có dữ liệu"
                      data={listVendor.map((employee) => ({
                        value: employee.value,
                        label: employee.text,
                      }))}
                      limit={20}
                      onClick={async () => await fetchDataVendor()}
                      searchable
                      //    withAsterisk
                      {...form.getInputProps("partnerId")}
                    />
                  </Grid.Col>
                  <Grid.Col span={{ base: 6 }}>
                    {" "}
                    <DateInput
                      key={form.key("createDate")}
                      readOnly
                      label="Ngày tạo:"
                      valueFormat="DD/MM/YYYY"
                      //    rightSection={<IconCalendarDue color="black" />}
                      placeholder="Vui lòng chọn ngày tạo"
                      clearable
                      {...form.getInputProps("createDate")}
                    />
                  </Grid.Col>{" "}
                  <Grid.Col span={{ base: 6 }}>
                    {" "}
                    <DateInput
                      key={form.key("signedDate")}
                      label="Ngày ký:"
                      minDate={form.values.createDate}
                      //  rightSection={<IconCalendarDue color="black" />}
                      valueFormat="DD/MM/YYYY"
                      clearable
                      placeholder="Vui lòng chọn ngày ký"
                      {...form.getInputProps("signedDate")}
                      // onChange={(e) => {
                      //   if (e) {
                      //     // Tạo bản sao của ngày được chọn và thêm 7 tiếng
                      //     let adjustedDate = new Date(e);
                      //     adjustedDate.setHours(adjustedDate.getHours() + 7);
                      //     form.setFieldValue("signedDate", adjustedDate);
                      //   } else {
                      //     form.setFieldValue("signedDate", undefined);
                      //   }
                      // }}
                    />
                  </Grid.Col>{" "}
                  <Grid.Col span={{ base: 6 }}>
                    <DateInput
                      key={form.key("startDate")}
                      minDate={form.values.createDate}
                      label="Hiệu lực từ:"
                      //  rightSection={<IconCalendarDue color="black" />}
                      placeholder="Chọn ngày"
                      valueFormat="DD/MM/YYYY"
                      clearable
                      {...form.getInputProps("startDate")}
                      // onChange={(e) => {
                      //   if (e) {
                      //     // Tạo bản sao của ngày được chọn và thêm 7 tiếng
                      //     let adjustedDate = new Date(e);
                      //     adjustedDate.setHours(adjustedDate.getHours() + 7);
                      //     form.setFieldValue("startDate", adjustedDate);
                      //   } else {
                      //     form.setFieldValue("startDate", undefined);
                      //   }
                      // }}
                    />
                  </Grid.Col>{" "}
                  <Grid.Col span={{ base: 6 }}>
                    <DateInput
                      key={form.key("expirationDate")}
                      minDate={form.values.createDate}
                      label="Có hiệu lực đến:"
                      //    rightSection={<IconCalendarDue color="black" />}
                      placeholder="Chọn ngày"
                      valueFormat="DD/MM/YYYY"
                      clearable
                      {...form.getInputProps("expirationDate")}
                      // onChange={(e) => {
                      //   if (e) {
                      //     // Tạo bản sao của ngày được chọn và thêm 7 tiếng
                      //     let adjustedDate = new Date(e);
                      //     adjustedDate.setHours(adjustedDate.getHours() + 7);
                      //     form.setFieldValue("expirationDate", adjustedDate);
                      //   } else {
                      //     form.setFieldValue("expirationDate", undefined);
                      //   }
                      // }}
                    />
                  </Grid.Col>{" "}
                  <Grid.Col span={{ base: 12 }}>
                    <Checkbox.Group
                      label="Cảnh báo hết hiệu lực:"
                      description=""
                    >
                      <Group mt="xs">
                        {options.map((option: any) => (
                          <Checkbox
                            key={option.value}
                            // checked={checkedValue === option.value}
                            //  onChange={() => handleCheckboxChange(option.value)}
                            // color="lime.4"
                            // iconColor="dark.8"
                            size="md"
                            label={option.label}
                            value={option.value}
                          />
                        ))}
                      </Group>
                    </Checkbox.Group>
                  </Grid.Col>{" "}
                </Grid>

                {/* <Group mb={25} align="center" justify="space-between">
                  <Text style={{ flex: "0 0 160px", whiteSpace: "nowrap" }}>
                    Cảnh báo hết hiệu lực:
                  </Text>
                  <Flex gap={25}>
                    {options.map((option: any) => (
                      <Checkbox
                        key={option.value}
                        checked={checkedValue === option.value}
                        onChange={() => handleCheckboxChange(option.value)}
                        color="lime.4"
                        iconColor="dark.8"
                        size="md"
                        label={option.label}
                      />
                    ))}
                  </Flex>
                </Group> */}
                <Box h={height - 350} className={className.DragAndDrop_content}>
                  <Box
                    h={height - 350}
                    className={className.DragAndDrop_content}
                  >
                    <Fieldset
                      style={{ display: "flex", justifyContent: "center" }}
                      legend="Tài liệu đính kèm"
                      p={10}
                    >
                      <Flex
                        className={className.style_container}
                        align="center"
                        justify="center"
                        direction="column"
                      >
                        <Box className={className.Box_animation_left}>
                          <Dropzone
                            onDrop={async (acceptedFiles) => {
                              if (acceptedFiles.length > 0) {
                                const res = await uploadFile(acceptedFiles);
                                if (res && res.length > 0)
                                  setListUploadedFiles((prev) => [
                                    ...prev,
                                    ...res,
                                  ]);
                                res?.forEach((element) => {
                                  const value = form.getValues().attachments;
                                  if (!value || value.length < 1) {
                                    form.setFieldValue(
                                      "attachments",
                                      element.url
                                    );
                                  } else
                                    form.setFieldValue(
                                      "attachments",
                                      value + "||" + element.url
                                    );
                                });
                              } else
                                NotificationExtension.Info(
                                  "Vui lòng chọn tập tin !"
                                );
                            }}
                            accept={[MIME_TYPES.pdf]}
                            multiple
                          >
                            <Box className="DragAndDrop_children">
                              <Center>
                                <UploadIconPlus width={70} height={70} />
                              </Center>
                              <Flex align="center" justify="center" gap={5}>
                                <Text size="sm">Kéo thả File của bạn</Text>
                                <Text
                                  td="underline"
                                  fw={600}
                                  c="blue"
                                  size="sm"
                                >
                                  hoặc chọn tệp tin
                                </Text>
                              </Flex>
                            </Box>
                          </Dropzone>
                        </Box>
                        <Box className={className.Box_animation_right} mt={16}>
                          <Flex
                            align="center"
                            justify="center"
                            direction="column"
                          >
                            {form.getValues().attachments?.length > 0 ? (
                              form
                                .getValues()
                                .attachments.split("||")
                                .filter((x) => x && x.length > 0)
                                .map((url, index) => (
                                  <Group key={index} mt="sm">
                                    <Text size="sm">
                                      {listUploadedFiles.find(
                                        (file) => file.url === url
                                      )?.fileNameBeforeUpdate ??
                                        url.split("/").pop() ??
                                        "Tài liệu"}
                                    </Text>
                                    <Button
                                      leftSection={<IconTrash size={14} />}
                                      color="red"
                                      size="xs"
                                      variant="light"
                                      onClick={() => {
                                        if (url) {
                                          const updatedAttachments = form
                                            .getValues()
                                            .attachments.split("||")
                                            .filter(
                                              (item) =>
                                                item !== url && item.length > 0
                                            )
                                            .join("||");
                                          form.setFieldValue(
                                            "attachments",
                                            updatedAttachments
                                          );
                                        }
                                      }}
                                    >
                                      Xoá
                                    </Button>
                                  </Group>
                                ))
                            ) : (
                              <Text size="sm" c="gray">
                                Không có tệp tin nào được đính kèm
                              </Text>
                            )}
                          </Flex>
                        </Box>
                      </Flex>
                    </Fieldset>
                  </Box>
                </Box>
              </ScrollArea>
            </Card>
          </Grid.Col>
        </Grid>
      </Box>
    </>
  );
};

type PartnersCreateViewProps = {
  onClose?: any;
};
